import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';

export const DocumentSearchBlockConfigSchema = z.object({
  searchQuery: z.string(),
});

export type DocumentSearchBlockConfig = z.infer<typeof DocumentSearchBlockConfigSchema>;

export const DocumentSearchBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.DocumentSearch),
  config: DocumentSearchBlockConfigSchema,
});

export type DocumentSearchBlock = z.infer<typeof DocumentSearchBlockSchema>;
